export type Modify<T, R> = Omit<T, keyof R> & R

/**
 * Empty, non-nullable `object` with no properties.
 *
 * Use this when expecting object, but with no particular properties as both `{}` and `object` are
 * discoraged due to their weird semantics.
 *
 * @see https://www.totaltypescript.com/the-empty-object-type-in-typescript
 */
export type EmptyObject = Record<string, never>

export type ValueOf<T> = T[keyof T]

export function isNotNullOrUndefined<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined
}
